import { render } from "./AuthError.vue?vue&type=template&id=21675c78&scoped=true"
import script from "./AuthError.vue?vue&type=script&lang=js"
export * from "./AuthError.vue?vue&type=script&lang=js"

import "./AuthError.vue?vue&type=style&index=0&id=21675c78&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21675c78"],['__file',"src/scripts/view/review/modals/loginModals/AuthError.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21675c78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21675c78', __exports__)) {
    api.reload('21675c78', __exports__)
  }
  
  module.hot.accept("./AuthError.vue?vue&type=template&id=21675c78&scoped=true", () => {
    api.rerender('21675c78', render)
  })

}


export default __exports__